import React, { createContext, useContext, useMemo, useState } from "react";

import { AccidentPlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: AccidentPlan;
  planCost: PlanCost;
}
interface AccidentContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: AccidentPlan | null;
  planCost: PlanCost | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const AccidentContext = createContext<AccidentContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: AccidentPlan;
  planCost: PlanCost;
}
export const AccidentContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<AccidentPlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      hide();
    };

    return { openEnrollmentModal, plan: _plan, planCost: _planCost, isShowing, hideEnrollmentModal };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <AccidentContext.Provider value={contextValue}>{children}</AccidentContext.Provider>;
};

export const useAccidentContext = () => useContext(AccidentContext);
